module.exports = __webpack_public_path__ + "img/ChatSim.c11cb832.jpg";